import { render, staticRenderFns } from "./uploadpdf.vue?vue&type=template&id=33dc2606&"
import script from "./uploadpdf.vue?vue&type=script&lang=js&"
export * from "./uploadpdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports